import { useMemo } from 'react';
import { Bot } from 'grts-utils/types/Bot';
import { Subscription } from '../../../types/subscription';
import { ProfitChartApiResponse } from '../../Detail/Charts/types';
import { SingleProfitCalculationApiResponse } from '../../ProfitCalculations/types';
import { ResultProvider } from '../Content/Calculations/context';
import ProfitChart from '../Content/Calculations/Result/ProfitChart';
import Hero from '../Content/Calculations/Result/Hero';
import Config from '../Content/Calculations/Result/Config';
import { tokens } from '../Content/Calculations/tokens';
import '../Content/Calculations/styles.css';
import { subscriptionToDisplayData } from '../data/subscriptionToDisplayData';

interface Props {
  subscription: Subscription;
  bot: Bot | undefined;
  spc: SingleProfitCalculationApiResponse | undefined;
  chartData: ProfitChartApiResponse | undefined;
}

/**
 * Overview tab — the first three editorial sections of the profit-result page
 * (main profit chart, profit-values hero, variables/config), reused verbatim and
 * fed with the live subscription's data via the shared ResultProvider.
 */
const Overview = ({ subscription, bot, spc, chartData }: Props) => {
  const displayData = useMemo(
    () => subscriptionToDisplayData(subscription, bot, { spc, chartData }),
    [subscription, bot, spc, chartData],
  );

  return (
    <ResultProvider data={displayData}>
      <div
        style={{
          // Transparent so the content root's profit wash shows through the
          // top of the page (the #000 here just duplicated the page background).
          background: 'transparent',
          color: tokens.textPrimary,
          fontFamily: tokens.fontSans,
          width: '100%',
          maxWidth: 1400,
          margin: '0 auto',
          boxSizing: 'border-box',
        }}
      >
        <ProfitChart />
        <Hero />
        <Config />
        <div style={{ height: 32 }} />
      </div>
    </ResultProvider>
  );
};

export default Overview;
